export { InstagramIcon } from './social-instagram'
